import { Country } from './../business-entities/country.model';
import { DealerDetailsListViewModel } from './../business-entities/dealer-details-view-model';
import { DealerRequestModel, DealerViewModel } from './../business-entities/dealer-view-model';
import { Injectable } from "@angular/core";
import { GenericResponse } from '../business-entities/generic-response';
import { DealerDataService } from '../data-services/dealer-data.service';
import { DealerServiceDetailsListViewModel } from '../business-entities/dealer-service-details-list-view-model';
import { DealerHolidayViewModel } from '../business-entities/dealer-holiday-list-view-model';
import { DealerBrandViewModel } from '../business-entities/dealer-brand-view-model';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { OlbDealerConfigViewModel, OlbDealerDetailViewModel, OlbDealerViewModel } from '../business-entities/olb-dealer.model';

@Injectable({
    providedIn: 'root'
})


export class DealerBusinessService {

    dealerId: string;
    searchTerm: string = '';
    dealerList: Array<SelectListItemViewModel>;
    constructor(private dealerDataService: DealerDataService) {
    }

    async getDealerList(dealerRequestModel:DealerRequestModel) {
        let dealerList: DealerViewModel[] = [];
        await this.dealerDataService
            .getDealerList(dealerRequestModel)
            .then(
                (res: GenericResponse<Array<DealerViewModel>>) => {
                    dealerList = res.responseObject;
                }
            );
        return dealerList;
    }
    async getDealerBrandList() {
        let dealerList: any;
        await this.dealerDataService
            .getDealerBrandList()
            .then(
                (res: GenericResponse<any>) => {
                    dealerList = res.responseObject;
                }
            );
        return dealerList;
    }
    async getDealerServiceList(dealerId: string, languageCode: string) {
        let dealerServiceDetailsList: DealerServiceDetailsListViewModel;
        await this.dealerDataService
            .getDealerServiceList(dealerId,languageCode)
            .then(
                (res: GenericResponse<DealerServiceDetailsListViewModel>) => {
                    dealerServiceDetailsList = res.responseObject;
                }
            );
     
        return dealerServiceDetailsList;
    }

    async getDealerDetails(dealerId: string) {
        let dealerDetails: DealerDetailsListViewModel;
        await this.dealerDataService
            .getDealerDetails(dealerId)
            .then(
                (res: GenericResponse<DealerDetailsListViewModel>) => {
                    dealerDetails = res.responseObject;
                }
            );
        return dealerDetails;
    }

    deleteDealer(id: string) {
        return this.dealerDataService.deleteDealer(id);
    }

    getBrandLogo(logo: string): string {
        let imageUrl = 'assets/images/brandlogo/';
        imageUrl = imageUrl + logo;

        if (logo == null)
            imageUrl = 'assets/images/brandlogo/' + 'no-logo.svg';
        return imageUrl;
    }

    async getDealerWiseHolidayList(dealerId: string) {
        let dealerHolidayList: Array<DealerHolidayViewModel> = [];
        await this.dealerDataService
            .getDealerWiseHolidayList(dealerId)
            .then(
                (res: GenericResponse<Array<DealerHolidayViewModel>>) => {
                    dealerHolidayList = res.responseObject;
                }
            );
       
        return dealerHolidayList;
    }

    updateDealer(dealerDetails: DealerViewModel) {
        return this.dealerDataService.updateDealer(dealerDetails);
    }

    addDealer(dealerDetails: DealerViewModel) {
        return this.dealerDataService.addDealer(dealerDetails);
    }

    addDealerBrand(dealerBrandDetails: DealerBrandViewModel) {
        return this.dealerDataService.addDealerBrand(dealerBrandDetails);
    }
    
    deleteDealerBrand(dealerBrandDetails: DealerBrandViewModel) {
        return this.dealerDataService.deleteDealerBrand(dealerBrandDetails);
    }
    editDealerBrand(dealerBrandDetails: DealerBrandViewModel) {
        return this.dealerDataService.editDealerBrand(dealerBrandDetails);
    }

    async getAllCountries(): Promise<Country[]> {
        let countryDetails: Country[];
        await this.dealerDataService.getAllCountries()
            .then(result => {
                countryDetails = result.responseObject
            });
        return countryDetails;
    }

     GetDealerWorkingHoursAndHoliday(dealerId: string)
     {
         return this.dealerDataService.GetDealerWorkingHoursAndHoliday(dealerId);
     }

     async getUserDealersDropdown() {
        let dealerList: any;
        await this.dealerDataService
            .getUserDealersDropdown()
            .then(
                (res: GenericResponse<any>) => {
                    dealerList = res.responseObject;
                }
            );
        return dealerList;
    }

    async getLocationCode() {
        let locationList: any;
        await this.dealerDataService
            .getLocationCode()
            .then(
                (res: GenericResponse<any>) => {
                    locationList = res.responseObject;
                }
            );
        return locationList;
    }

    async OlbGetDealers(name: string) {
        let dealerList: OlbDealerViewModel[] = [];
        await this.dealerDataService.OlbGetDealers(name)
            .then((res: GenericResponse<Array<OlbDealerViewModel>>) => {
                dealerList = res.responseObject;
            });
        return dealerList;
    }
    async OlbGetDealerDetail(dealerDmsNo: string) {
        let dealerDetail: OlbDealerDetailViewModel;
        await this.dealerDataService.OlbGetDealerDetail(dealerDmsNo)
            .then((res: GenericResponse<OlbDealerDetailViewModel>) => {
                dealerDetail = res.responseObject;
            });
        return dealerDetail;
    }
    async OlbGetDealerConfig(dealerDmsNo: string) {
        let dealerConfig: OlbDealerConfigViewModel;
        await this.dealerDataService.OlbGetDealerConfig(dealerDmsNo)
            .then((res: GenericResponse<OlbDealerConfigViewModel>) => {
                dealerConfig = res.responseObject;
            });
        return dealerConfig;
    }
    async ResyncDealer(dealerId: string): Promise<GenericResponse<boolean>> {
        return await this.dealerDataService.ResyncDealer(dealerId);
    }

    async GetWidgetServiceReport(model:any){
        return await this.dealerDataService.GetWidgetServiceReport(model);
    }
}